import { inject, Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { tap } from 'rxjs/operators';
import { showSnackbar } from './snackbar.actions';

@Injectable()
export class SnackbarEffects {
  private actions$ = inject(Actions);
  private snackBar = inject(MatSnackBar);

  show$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(showSnackbar),
        tap(({ payload }) => {
          this.snackBar.open(payload.message, '', {
            duration: 5000,
          });
        }),
      ),
    { dispatch: false },
  );
}
